import { Route, Routes } from "react-router-dom";
import FormacionDocente from "../newPages/homenew/FormacionDocente";
import PresencialHorarios from "../newPages/homenew/PresencialHorarios";
import PresencialResultados from "../newPages/homenew/PresencialResultados";
import Posgrados from "../newPages/homenew/Posgrados";
import ActividadesExtracurriculares from "../newPages/homenew/ActividadesExtracurriculares";
import EscuelaNegocios from "../newPages/homenew/EscuelaNegocios";
import DecideSerMas from "../newPages/homenew/DecideSerMas";
import Presencial from "../newPages/homenew/Presencial";
import Referidos from "../newPages/homenew/Referidos";
import SegundaLengua from "../newPages/homenew/SegundaLengua";


function NewRoutes() {
  return (
    <>
 
        <Route path="/presencial" element={<Presencial />} />
        <Route
          path="/formacion-docente"
          element={<FormacionDocente></FormacionDocente>}
        />{" "}
        <Route
          path="/horarios-prueba-admision"
          element={<PresencialHorarios></PresencialHorarios>}
        />
        <Route
          path="/resultados-prueba-admision"
          element={<PresencialResultados />}
        />
        <Route
          path="/actividades-extracurriculares"
          element={<ActividadesExtracurriculares />}
        />
        <Route path="/decide-ser-mas" element={<DecideSerMas />} />
        <Route path="/posgrados" element={<Posgrados />} />
        <Route path="/escuela-negocios" element={<EscuelaNegocios />} />
        <Route path="/referidos" element={<Referidos />} />
            <Route path="/segunda-lengua" element={<SegundaLengua />} />
        
 
    </>
  );
}

export default NewRoutes;
